import { GlobalAxios } from "../axios/axios-config";
import { ITasySectorAccommodationType } from "../models/tasy-sector-accommodation-type";

// Backfilled 2026-07-30 (#2948): originally pointed at the generic DomainValue?Identifier=12
// route, which turned out to be wrong - cd_tipo_acomodacao is backed by the tipo_acomodacao
// registration table, not a Tasy system domain (confirmed via tabela_atributo + Mauricio).
const SECTOR_ACCOMMODATION_TYPE_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/AccommodationType/AccommodationType";

export const getSectorAccommodationTypesList = (params?: any) => {
  return GlobalAxios.get<ITasySectorAccommodationType[]>(
    SECTOR_ACCOMMODATION_TYPE_ROUTE,
    {
      params,
    },
  );
};
